var _g, _use, _use2, _use3, _use4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-873 -2386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Trash_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__a",
    fill: "#fff",
    transform: "translate(875 2390)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Trash_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__c",
    fill: "currentColor",
    transform: "translate(875 2390)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__d",
    fill: "currentColor",
    transform: "translate(0 5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__e",
    fill: "currentColor",
    transform: "matrix(0 1 -1 0 7 8)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__e",
    fill: "currentColor",
    transform: "matrix(0 1 -1 0 11 8)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Trash_svg__f",
    fill: "currentColor",
    transform: "translate(6 1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Trash_svg__a",
    d: "M0 0h14v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trash_svg__c",
    d: "M0 0v-2h-2v2zm14 0h2v-2h-2zm0 16v2h2v-2zM0 16h-2v2h2zM0 2h14v-4H0zm12-2v16h4V0zm2 14H0v4h14zM2 16V0h-4v16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trash_svg__d",
    d: "M0 1h18v-2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trash_svg__e",
    d: "M0 1h8v-2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trash_svg__f",
    d: "M0 1h6v-2H0z"
  }))));
};
export default SvgTrash;